import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Products API
export const productsAPI = {
  getAll: () => apiClient.get('/products/'),
  getById: (id) => apiClient.get(`/products/${id}`),
  create: (data) => apiClient.post('/products/', data),
  update: (id, data) => apiClient.put(`/products/${id}`, data),
  delete: (id) => apiClient.delete(`/products/${id}`),
};

// Reviews API  
export const reviewsAPI = {
  getAll: (productFilter = null) => {
    const params = productFilter ? { product: productFilter } : {};
    return apiClient.get('/reviews/', { params });
  },
  getById: (id) => apiClient.get(`/reviews/${id}`),
  create: (data) => apiClient.post('/reviews/', data),
  update: (id, data) => apiClient.put(`/reviews/${id}`, data),
  delete: (id) => apiClient.delete(`/reviews/${id}`),
};

// Contact API
export const contactAPI = {
  send: (data) => apiClient.post('/contact/', data),
  getAll: () => apiClient.get('/contact/'), // Admin only
};

// Generic API error handler
export const handleAPIError = (error) => {
  if (error.response) {
    return error.response.data.detail || 'An error occurred';
  }
  if (error.request) {
    return 'Network error. Please check your connection.';
  }
  return error.message;
};

export default apiClient;
